import type { ValidationArgs } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export interface LicenseOrderXmlForm {
  xmlFile: File | undefined;
  importForCompany: boolean;
}

export function getLicenseOrderXmlFormRules(
  _unusedForm: LicenseOrderXmlForm,
): ValidationArgs<LicenseOrderXmlForm> {
  return {
    xmlFile: { required },
    importForCompany: {},
  };
}

export const validationMessages: Record<keyof LicenseOrderXmlForm, object> = {
  xmlFile: {
    required: "Please upload a file.",
  },
  importForCompany: {},
};

export const fieldLabelsMap: Record<keyof LicenseOrderXmlForm, string> = {
  xmlFile: "License Order XML File",
  importForCompany: "Import as company licenses",
};
